// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 6px;
}

.step-hint {
  color: #555;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
}

.material-search-bar {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.5rem;
}
.material-search-bar input {
  flex: 1;
}

.selected-material-badge {
  background: #e8f4e8;
  border: 1px solid #a3d9a5;
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.material-table-wrapper {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 0.75rem;
}

.clear-btn {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/add-mud-check-material-dialog/add-mud-check-material-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AACF;AACE;EACE,OAAA;AACJ;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 6px;\n}\n\n.step-hint {\n  color: #555;\n  font-size: 0.875rem;\n  margin-bottom: 0.75rem;\n}\n\n.material-search-bar {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 0.5rem;\n\n  input {\n    flex: 1;\n  }\n}\n\n.selected-material-badge {\n  background: #e8f4e8;\n  border: 1px solid #a3d9a5;\n  border-radius: 4px;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.85rem;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n}\n\n.material-table-wrapper {\n  max-height: 320px;\n  overflow-y: auto;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  margin-bottom: 0.75rem;\n}\n\n.clear-btn {\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
